<template>
  <div>
        <div>
        <el-table
            v-if="dataList.length>0"
            :data="dataList"
            style="width: 100%">
          
          <el-table-column 
            prop="created_at"
            sortable
            label="Assigned On" width="130">
            <template slot-scope="scope">
                <span class="rowFontSize">
                  {{changeDate(scope.row.created_at)}}
                </span>
            </template>
          </el-table-column>

          <el-table-column 
            prop="task_time"
            sortable
            label="Task Date" width="170">
            <template slot-scope="scope">
                <span class="rowFontSize">
                  {{scope.row.task_type === 0 ? changeDate(scope.row.task_time) : scope.row.task_time_changed}}
                </span>
            </template>
          </el-table-column>

          <el-table-column 
            prop="revision_count"
            sortable
            label="Revised" width="170">
            <template slot-scope="scope">
                <span class="rowFontSize">
                  <span v-if="scope.row.revision_count>0" style="color: red; font-size: 11px;">
                    {{scope.row.revision_count}} times
                  </span>
                </span>
            </template>
          </el-table-column>

          <el-table-column 
            prop="title"
            sortable
            label="Title" width="300">
            <template slot-scope="scope">
                <span class="rowFontSize">
                  {{scope.row.title_prefix}}{{scope.row.title}}
                </span>
                
            </template>
          </el-table-column>

          <el-table-column 
            prop="assigned_to_name"
            sortable
            label="Assigned To" width="200">
            <template slot-scope="scope">
                <span class="rowFontSize">
                  {{scope.row.assigned_to_alias_name !== null && scope.row.assigned_to_alias_name.length>0 ? scope.row.assigned_to_alias_name : scope.row.assigned_to_name}}
                </span>
            </template>
            </el-table-column>

          <el-table-column 
            prop="created_by_name"
            sortable
            label="Created By" width="200">
            <template slot-scope="scope">
                <span class="rowFontSize">
                  {{scope.row.created_by_alias_name !== null && scope.row.created_by_alias_name.length>0 ? scope.row.created_by_alias_name : scope.row.created_by_name}}
                </span>
            </template>
            </el-table-column>  
         
          <el-table-column 
            prop="priority"
            sortable
            label="Type" align="center" width="120">
            <template slot-scope="scope">
                <el-tag :type="scope.row.priority === 0 ? 'info' : scope.row.priority === 1 ? 'warning' : scope.row.priority === 2 ? 'danger' : ''">
                  {{
                    scope.row.priority === 0 ? 'Normal' : scope.row.priority === 1 ? 'Medium' : scope.row.priority === 2 ? 'Urgent' : ''
                  }}
                </el-tag>                
            </template>
          </el-table-column>
          <el-table-column 
            prop="status"
            sortable
            label="Status" align="center" width="120">
            <template slot-scope="scope">
                <el-tag :type="scope.row.status === 0 ? 'info' : scope.row.status === 1 ? 'warning' : scope.row.status === 2 ? 'warning' : scope.row.status === 3 ? 'danger' : 'success'">
                  {{
                    scope.row.status === 0 ? 'New' : scope.row.status === 1 ? 'WIP' : scope.row.status === 2 ? 'Completed' : scope.row.status === 3 ? 'Rejected' : 'Accepted'
                  }}
                </el-tag>  
            </template>
          </el-table-column>
          <el-table-column
                fixed="right"
                label=""
                width="120">
                <template slot-scope="scope">
                    <div style="text-align: right; display: flex; flex-direction: row; justify-content: flex-end; align-items: flex-end;">
                        <el-tooltip class="item" effect="dark" :content="($store.getters.getUserInformation.staff_id === scope.row.created_by_staff_id) ? 'Edit' : 'View'">
                          <a @click="$store.dispatch('fetchTaskData', {id: scope.row.id})" style="cursor: pointer;">
                            <i :class="$store.getters.getLoadingState ? 'el-icon-loading' : ($store.getters.getUserInformation.staff_id === scope.row.created_by_staff_id) ? 'el-icon-edit' : 'el-icon-view'"></i>
                          </a>
                        </el-tooltip>
                        
                        <el-tooltip class="item" effect="dark" content="Delete">
                          <el-popconfirm
                              @confirm="$store.dispatch('deleteTaskData', {id: scope.row.id})"
                              title="Are you sure to delete this?"
                              >
                                <a v-if="$store.getters.getUserInformation.staff_id === scope.row.created_by_staff_id" slot="reference" style="cursor: pointer; margin-left: 10px; color: red;">
                                  <i class="el-icon-delete"></i>
                                </a>
                              
                          </el-popconfirm>
                        </el-tooltip>
                        
                    </div>                                        
                </template>
            </el-table-column>
        </el-table>
        <el-empty description="No Data" v-else>
            
        </el-empty>
        </div>
  </div>
</template>

<script>
export default {
    props: ['dataList']
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Tasks/List.vue